export const blob2base64 = (blob: Blob): Promise<string | ArrayBuffer | null> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

export const base64UrlToBlob = async (base64: string): Promise<Blob> => {
    const base64Response = await fetch(base64);
    const blob = await base64Response.blob();

    if (!blob) {
        console.error('Failed to convert base64 to blob');
        return;
    }
    return blob;
};

export const resizeImage = async (file: File, maxSize: number) => {
    if (!file.type.startsWith('image/')) {
        throw new Error('Not an image');
    }

    if (!maxSize || maxSize < 100) {
        throw new Error('Max size cannot be lower than 100px');
    }

    const bitmap = await createImageBitmap(file);

    let scale;
    // Scale down the image if one side is larger than maxSize
    if (bitmap.width <= maxSize && bitmap.height <= maxSize) {
        scale = 1;
    } else if (bitmap.width > bitmap.height) {
        scale = maxSize / bitmap.width;
    } else {
        scale = maxSize / bitmap.height;
    }

    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width * scale;
    canvas.height = bitmap.height * scale;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);

    const dataUrl = canvas.toDataURL('image/jpeg', 0.9);
    const blob = await base64UrlToBlob(dataUrl);
    return new File([blob], file.name.replace(/(\.\w+$)/, '.jpeg'), { type: blob.type });
};
